import styled from 'styled-components';

export const NutritionFactsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SubNutritionFacts = styled.div`
  padding-left: 24px;
`;
